import type { History } from 'history';

import { requireAuthenticationFactory } from '@kotify/rehelpers/authUtils';
import { store } from 'vms/app/configureApp';

import { SAVE_LAST_LOCATION } from './actionTypes';

const checkAuthenticated = (history: History, { redirect = '/login/' } = {}) => {
  const state = store.getState();
  if (!state.accounts.isAuthenticated) {
    store.dispatch({ type: SAVE_LAST_LOCATION, pathname: history.location.pathname });
    history.replace(redirect);
  }
};

const checkUnauthenticated = (history: History, { redirect = '/' } = {}) => {
  const state = store.getState();
  if (state.accounts.isAuthenticated) {
    history.replace(redirect);
  }
};

export const requireAuthenticated = requireAuthenticationFactory(checkAuthenticated);
export const requireUnauthenticated = requireAuthenticationFactory(checkUnauthenticated);
